<script lang="ts">
    interface Props {
        label: string;
    }

    let { label }: Props = $props();
</script>

<div class="flex text-sm text-mdark-lighter pb-0 pt-7 first:pt-0 relative bold">
    {label}
</div>
